// Display constants for the customer module. Source labels mirror the lead
// module's table so badges read the same across the app.

import type { CustomerSource } from "@/types/customer";

export const CUSTOMER_SOURCES: readonly CustomerSource[] = [
  "WALK_IN",
  "FACEBOOK",
  "ZALO",
  "REFERRAL",
  "OTHER",
] as const;

export const CUSTOMER_SOURCE_LABELS: Record<CustomerSource, string> = {
  WALK_IN: "Khách vãng lai",
  FACEBOOK: "Facebook",
  ZALO: "Zalo",
  REFERRAL: "Giới thiệu",
  OTHER: "Khác",
};
